import React, { useState } from "react";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import SVGComponent from "../../SVGComponent";

// Suggested prop reference for consumers -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)} OnClickEventHandler
 */
/**
 * @typedef {Object} ChipItem
 * @property {string} text - Chip label.
 * @property {boolean} selected - Highlight chip and render bullet list when true.
 * @property {boolean} [disabled] - Disable click/hover behaviour.
 * @property {HoverOption} [hoverOption] - Hover theme for enabled chips.
 * @property {(e: React.MouseEvent<HTMLDivElement>, index: number, chip: ChipItem) => void} [onClick] - Chip click handler.
 */
/**
 * @param {Object} props
 * @param {string} props.headerTitle - Main heading text displayed at the top.
 * @param {string} [props.headerFontWeight] - Heading font weight class (e.g. "normal", "semibold", "bold").
 * @param {string} [props.headerFontColor] - Heading text color class (e.g. "text-primary").
 * @param {ChipItem[]} props.chipsArray - Interactive options rendered as chips.
 *  * @param {OnClickEventHandler} [props.closehandleFunction] - Handle function when close button is clicked
 * @param {string} [props.closeiconImg] - Icon/SVG image path for close button
 * @param {boolean} [props.closeisDisabled] - Disable close button (true/false)
 * @param {string} [props.closedisabledBgColor] - Background color when close button is disabled (CSS variable)
 * @param {React.RefObject} [props.closebuttonRef] - Button ref for close button (optional)
 * @param {string} [props.closeimgColor] - Icon color for close button (CSS variable)
 * @returns {JSX.Element}
 */
const CommonReminderRedirectPopup = ({
  headerTitle,
  closeiconhandleFunction,
  closeisDisabled,
  closedisabledBgColor,
  closebuttonRef,
  closeimgColor,
  chipsArray,
}) => {
  const safeChipsArray = Array.isArray(chipsArray) ? chipsArray : [];
  const [animate, setAnimate] = useState(false);

  const toSentenceCase = (text = "") =>
    text.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
    text.slice(GlobalConfiguration?.lengthCheckOne).toLowerCase();

  return (
    <div
      className="flex w-full justify-center items-center m-auto top-1/2 left-1/2 fixed z-z-index-modal p-padding-sm"
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`h-height-full w-full Qmd:w-small-popup-width flex flex-col  py-padding-md bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div className="flex justify-between px-padding-md items-center">
          <p className={`text-text-primary   text-font-md font-semibold`}>
            {toSentenceCase(headerTitle)}
          </p>

          <IconRoundButton
            enabledBgColor={"var(--primary-nav)"}
            isLoading={false}
            handleFunction={() => {
              if (!closeisDisabled) {
                setAnimate(true);
                setTimeout(() => {
                  closeiconhandleFunction();
                }, IntervalConfiguration.intervalSemiMid);
              }
            }}
            title="Close"
            icon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
            hoverOption={"white"}
            btnType={"button"}
            isDisabled={closeisDisabled}
            disabledBgColor={closedisabledBgColor}
            buttonRef={closebuttonRef}
            imgColor={closeimgColor}
          />
        </div>

        <div className="mt-margin-md flex flex-col gap-gap-sm overflow-y-auto flex-1 px-padding-md">
          {safeChipsArray.map((item, index) => (
            <div
              key={index}
              className="flex flex-col gap-gap-xs"
            >
              <div
                onClick={(e) => {
                  if (!item.disabled && item?.onClick) {
                    item.onClick(e);
                  }
                }}
                className={`
          flex items-center gap-gap-sm  rounded-border-radius-md p-padding-md 
          bg-primary-nav 
          ${item.disabled ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer relative z-z-index-base global-hover-white"}  
        `}
              >
                <SVGComponent
                  url={item?.imgUrl}
                  color={item?.imgColor}
                  height={"var(--icon-lg)"}
                  width={"var(--icon-lg)"}
                />

                <p
                  className={`text-font-md font-normal text-text-primary
          `}
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommonReminderRedirectPopup;
